import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hint', 'select']

  connect() {
    this.updateHint()
  }

  updateHint() {
    this.hintTarget.textContent = this.#selectedOption()?.dataset?.hint
  }

  #selectedOption() {
    return this.selectTarget.selectedOptions.item(0)
  }
}
